<div class="product-list-container">
  <!-- Error Notification (Top Right) -->
  <div *ngIf="errorMessage" class="error-notification">
    <svg class="error-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#dc2626"/>
      <path d="M15 9L9 15M9 9L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="error-notification-message">{{ errorMessage }}</span>
  </div>
  <div class="page-header">
    <h2>Products</h2>
    <button class="btn btn-primary" routerLink="/product/add" *ngIf="!authService.isSupplier()">
      Add Product
    </button>
  </div>

  <!-- Search and Filters -->
  <div class="filters-bar">
    <div class="search-box">
      <input type="text" class="search-input" placeholder="Search by Product Name, ID" [(ngModel)]="searchTerm" (input)="onSearch()">
      <span class="search-icon">🔍</span>
    </div>
    <select class="filter-select" [(ngModel)]="selectedCategory" (change)="applyFilters()">
      <option value="">Filter by Product Category</option>
      <option *ngFor="let category of categories" [value]="category._id">{{ category.name }}</option>
    </select>
    <select class="filter-select" [(ngModel)]="selectedStatus" (change)="applyFilters()">
      <option value="">Filter by Status</option>
      <option value="Active">Active</option>
      <option value="Inactive">Inactive</option>
    </select>
    <button type="button" class="btn btn-reset" (click)="resetFilters()">Reset</button>
  </div>

  <!-- Products Table -->
  <div class="table-container" #tableContainer *ngIf="!loading && products.length > 0">
    <table class="product-table">
      <thead>
        <tr>
          <th>Product ID</th>
          <th>Product Details</th>
          <th *ngIf="!authService.isSupplier()">Shared With</th>
          <th>Status</th>
          <th>Product Details</th>
          <th>Image</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products">
          <td>{{ getProductId(product) }}</td>

     
          <td>
            <div class="product-details-cell">
              <div class="product-name">Product Name : {{ product.name }}</div>
              <div class="product-category" *ngIf="product.category">
                <span class="product-categoryName">Category Name : </span>
                <a *ngIf="!authService.isSupplier()" [routerLink]="['/product/category']" [queryParams]="getCategoryIdForView(product) ? { view: getCategoryIdForView(product) } : {}" class="category-link">
                  {{ product.category.name || getCategoryName(product.category._id || product.category) }}
                  <svg class="external-link-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 2V8M10 2H4M10 2L2 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </a>
                <span *ngIf="authService.isSupplier()" class="category-name-text">
                  {{ product.category.name || getCategoryName(product.category._id || product.category) }}
                </span>
              </div>
            </div>
          </td>
          <td *ngIf="!authService.isSupplier()">
            <a [routerLink]="['/product/view', product._id]" [queryParams]="{ tab: 'share' }" class="shared-with-link" [class.zero-count]="isSharedCountZero(product)" (click)="$event.stopPropagation()">
              {{ getSharedCount(product) }}
              <svg class="external-link-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 2V8M10 2H4M10 2L2 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
          </td>
          <td>
            <span *ngIf="product.status!='Deleted'" class="status-badge" [ngClass]="product.isActive ? 'status-active' : 'status-inactive'">
              {{ product.isActive ? 'Active' : 'Inactive' }}
            </span>
            <span *ngIf="product.status==='Deleted'" class="status-badge" [ngClass]="product.status ?  'status-inactive' : 'status-active' ">
              {{ product.status }}
            </span>
          </td>
          <td>
            <div class="product-info-cell">
              <div class="info-item">Created At: {{ formatDate(product.createdAt) }}</div>
              <div class="info-item">Created By: {{ product.createdBy?.name || 'Admin' }}</div>
            </div>
          </td>
          <td>
            <div class="product-image-cell">
              <img 
                *ngIf="getProductImage(product)" 
                [src]="getProductImage(product)" 
                [alt]="product.name"
                class="product-image"
                (error)="onImageError($event)">
              <div class="image-placeholder" [style.display]="getProductImage(product) ? 'none' : 'flex'">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="40" height="40" fill="#e5e7eb"/>
                  <path d="M20 12L25 18H15L20 12Z" fill="#9ca3af"/>
                  <rect x="10" y="20" width="20" height="12" fill="#9ca3af"/>
                </svg>
              </div>
            </div>
          </td>
          <td>
            <div class="actions-cell">
              <div class="action-menu" (click)="toggleActionMenu(product._id, $event); $event.stopPropagation()">
                <span class="dots-icon" title="More actions">⋮</span>
                <div class="action-dropdown" *ngIf="showActionMenu[product._id]" (click)="$event.stopPropagation()">
                  <a href="#" class="dropdown-item" (click)="viewProductDetails(product); $event.preventDefault(); $event.stopPropagation()">
                    View Details
                  </a>
                  <!-- <a href="#" class="dropdown-item" (click)="editProduct(product); $event.preventDefault(); $event.stopPropagation()">
                    Edit
                  </a> -->
                  <!-- Deactivate/Activate: Only Admin can access -->
                  <a href="#" class="dropdown-item deactivate" *ngIf="product.status!='Deleted'&&product.isActive && authService.isAdmin()" (click)="toggleProductStatus(product); $event.preventDefault(); $event.stopPropagation()">
                    Deactivate
                  </a>
                  <a href="#" class="dropdown-item activate" *ngIf="product.status!='Deleted'&&!product.isActive && authService.isAdmin()" (click)="toggleProductStatus(product); $event.preventDefault(); $event.stopPropagation()">
                    Activate
                  </a>
                  <!-- Delete: Only Admin can access -->
                  <a href="#" class="dropdown-item delete" *ngIf="product.status!='Deleted' && authService.isAdmin()" (click)="deleteProduct(product._id); $event.preventDefault(); $event.stopPropagation()">
                    Delete
                  </a>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    
    <!-- Infinite Scroll Loading Indicator -->
    <div class="infinite-scroll-loader" *ngIf="isLoadingMore">
      <div class="loader-spinner"></div>
      <span>Loading more products...</span>
    </div>
    
    <!-- End of Data Message -->
    <div class="end-of-data" *ngIf="!hasMoreData && !loading && products.length > 0">
      <p>No more products to load</p>
    </div>
  </div>

  <div class="empty-state" *ngIf="!loading && products.length === 0">
    <p>No products found</p>
  </div>

  <div class="loading-state" *ngIf="loading">
    <div class="loader-spinner"></div>
    <p>Loading products...</p>
  </div>

  <!-- Confirmation Modal -->
  <app-confirmation-modal
    [isOpen]="showConfirmModal"
    [message]="modalMessage"
    [confirmText]="modalConfirmText"
    (confirm)="onConfirmStatusChange()"
    (cancel)="closeConfirmModal()"
    (close)="closeConfirmModal()">
  </app-confirmation-modal>
</div>
